import { gql } from 'graphql-tag';

export const projectWorkflowFragment = gql`
  fragment ProjectWorkflow on ProjectWorkflowState {
    id
    uri
    displayText
  }
`;
